import { ButtonLink } from '@/components/ui/Button';
import { ROUTES } from '@/config/navigation';

export default function NotFoundPage() {
  return (
    <div className="cf-container flex min-h-[60vh] flex-col items-center justify-center text-center">
      <p className="text-sm font-semibold text-brand-600">Erreur 404</p>
      <h1 className="mt-2 text-3xl font-semibold text-ink-950">Cette page n’existe pas</h1>
      <p className="mt-2 max-w-md text-sm text-ink-600">
        Le lien est peut-être obsolète, ou la page n’a pas encore été mise en ligne.
      </p>
      <ButtonLink to={ROUTES.home} className="mt-6">
        Retour à l’accueil
      </ButtonLink>
    </div>
  );
}
